/**
 * Resolve EMR sync chip status.
 * Appointments only track posted_to_emr (no updated_in_emr*); patients/guarantors
 * require updated_in_emr confirmation after post.
 */

function isPatientEmrUpdateConfirmed(row) {
  return Boolean(
    row?.posted_to_emr &&
      row?.updated_in_emr &&
      row?.updated_in_emr_by != null &&
      String(row.updated_in_emr_by).trim() !== '' &&
      row?.updated_in_emr_at
  );
}

export function resolveEmrSyncChipStatus(props) {
  if (props.hasIntegration === false) {
    return 'none';
  }

  if (props.syncStatus && props.syncStatus !== 'none') {
    return props.syncStatus;
  }

  if (props.jobState === 'needs_attention' || props.jobState === 'failed') {
    return 'needs_attention';
  }

  if (props.awaitingEmrId) {
    return 'awaiting_emr_id';
  }

  // Appointments only track posted_to_emr / posted_by / posted_at — no updated_in_emr*.
  if (props.entityType === 'appointment') {
    if (props.postedToEmr) {
      return 'synced';
    }
    if (
      props.errorClass === 'manual_entry_required' ||
      props.jobState === 'blocked'
    ) {
      return 'update_pending';
    }
    if (props.jobState === 'pending' || props.jobState === 'in_progress') {
      return 'pending';
    }
    if (props.jobState === 'success') {
      return 'synced';
    }
    return 'none';
  }

  const emrUpdateConfirmed = isPatientEmrUpdateConfirmed({
    posted_to_emr: props.postedToEmr,
    updated_in_emr: props.updatedInEmr,
    updated_in_emr_by: props.updatedInEmrBy,
    updated_in_emr_at: props.updatedInEmrAt
  });

  if (props.postedToEmr && !emrUpdateConfirmed) {
    return 'update_pending';
  }

  if (emrUpdateConfirmed || props.jobState === 'success') {
    return 'synced';
  }

  if (
    props.errorClass === 'manual_entry_required' ||
    props.jobState === 'blocked'
  ) {
    return 'update_pending';
  }

  if (props.jobState === 'pending' || props.jobState === 'in_progress') {
    return 'pending';
  }

  return 'none';
}
